import { render } from "./BioIntelligentPart5.vue?vue&type=template&id=deaab80a"
const script = {}

import "./BioIntelligentPart5.vue?vue&type=style&index=0&id=deaab80a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__